/**
 * Page measures (design note salon-booking-premium-redesign.md section 5.2): content at most 1240 px
 * wide, with 16 px gutters on a phone, 32 on a tablet and 40 on a desktop. Sections breathe: 96 px
 * apart on a phone, 160 on a desktop.
 */
export const page = "mx-auto w-full max-w-[77.5rem] px-4 md:px-8 lg:px-10";

/** The page gutter undone, for a row that scrolls edge to edge (the team on a phone, the menu bar). */
export const bleed = "-mx-4 px-4 md:-mx-8 md:px-8";

/** The space between a page's sections. */
export const sectionGap = "gap-24 md:gap-32 lg:gap-40";

/** A section title that is not a landing-page headline: the display face, on the fluid scale. */
export const sectionTitle = "display-section text-heading";

/** A list's label on My bookings, "LATER" and "WAITLIST" on a phone, a title on a desktop (follow-up F10, F15). */
export const listLabel =
  "eyebrow px-1 text-muted lg:px-0 lg:text-xl lg:tracking-normal lg:text-heading lg:normal-case lg:font-semibold";
